import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { testimonialImages } from '../../data/testimonialImages';
const GAP_PX = 16;
export function Testimonials() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(true);
  const getSlideWidth = () => {
    const track = trackRef.current;
    const firstSlide = track?.children[0] as HTMLElement | undefined;
    if (!firstSlide) return 0;
    return firstSlide.getBoundingClientRect().width + GAP_PX;
  };
  const updateState = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;
    const slideWidth = getSlideWidth();
    if (slideWidth > 0) {
      setActiveIndex(Math.min(Math.round(track.scrollLeft / slideWidth), testimonialImages.length - 1));
    }
    setCanPrev(track.scrollLeft > 4);
    setCanNext(track.scrollLeft + track.clientWidth < track.scrollWidth - 4);
  }, []);
  useEffect(() => {
    updateState();
    window.addEventListener('resize', updateState);
    return () => window.removeEventListener('resize', updateState);
  }, [updateState]);
  const scrollByOne = (direction: 1 | -1) => {
    const track = trackRef.current;
    const slideWidth = getSlideWidth();
    if (!track || slideWidth === 0) return;
    track.scrollBy({
      left: direction * slideWidth,
      behavior: 'smooth'
    });
  };
  const scrollToIndex = (index: number) => {
    const track = trackRef.current;
    const slideWidth = getSlideWidth();
    if (!track || slideWidth === 0) return;
    track.scrollTo({
      left: index * slideWidth,
      behavior: 'smooth'
    });
  };
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-209" data-mp="r3tql5l24087">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-210" data-mp="r178ic0ji2bq">
        <SectionTag icon="💬" data-id="element-211" data-mp="m2vya06c1psz">Testimonios reales</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-212" data-mp="nl4eqh11d75t">
          Así están usando el material otros entrenadores
        </h2>
      </div>

      <div className="relative mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-213" data-mp="el7tkpduuqfi">
        <div ref={trackRef} onScroll={updateState} className="scrollbar-hide flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth" data-id="element-214" data-mp="en0qve2kvyau">
          {testimonialImages.map(item => <div key={item.src} className="flex h-[400px] w-full flex-shrink-0 snap-start items-center justify-center sm:h-[440px] md:w-[calc(50%-8px)]" data-id="element-215" data-mp="9ll85snvi3vm">
              <img src={item.src} alt={item.alt} loading="lazy" decoding="async" className="max-h-full max-w-full rounded-2xl object-contain" data-id="element-216" data-mp="3w167qmnkvlxj" />
            </div>)}
        </div>

        <button type="button" onClick={() => scrollByOne(-1)} disabled={!canPrev} aria-label="Testimonio anterior" className="absolute left-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-gris-claro bg-white/90 text-azul shadow-card backdrop-blur-sm transition-opacity duration-150 hover:bg-azul-light disabled:pointer-events-none disabled:opacity-0 sm:-left-4 sm:h-10 sm:w-10" data-id="element-217" data-mp="3n2kfu0w7uuk3">
          <ChevronLeftIcon size={20} data-id="element-218" data-mp="3mbquxspbz6ba" />
        </button>
        <button type="button" onClick={() => scrollByOne(1)} disabled={!canNext} aria-label="Siguiente testimonio" className="absolute right-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-gris-claro bg-white/90 text-azul shadow-card backdrop-blur-sm transition-opacity duration-150 hover:bg-azul-light disabled:pointer-events-none disabled:opacity-0 sm:-right-4 sm:h-10 sm:w-10" data-id="element-219" data-mp="3hdpezgn7bn41">
          <ChevronRightIcon size={20} data-id="element-220" data-mp="1ygufo010hise" />
        </button>
      </div>

      <div className="mt-5 flex items-center justify-center gap-2" data-id="element-221" data-mp="23f5pwbv7xvb5">
        {testimonialImages.map((item, i) => <button key={item.src} type="button" onClick={() => scrollToIndex(i)} aria-label={`Ir al testimonio ${i + 1}`} aria-current={activeIndex === i ? 'true' : undefined} className={`h-2 rounded-full transition-[width,background-color] duration-200 ${activeIndex === i ? 'w-6 bg-azul' : 'w-2 bg-gris-claro'}`} data-id="element-222" data-mp="285cdq9hwpbsc" data-mpi={i} />)}
      </div>
    </section>;
}